import React from 'react';
import { APIProvider } from '@vis.gl/react-google-maps';

import { GeoMapLoadErrorEvent } from '@rover/react-lib/src/components/GeoMap/analyticsEvents';
import { MapMetadata } from '@rover/react-lib/src/components/GeoMap/types';
import { Connect } from '@rover/react-lib/src/components/utils/Redux';
import {
  actions as searchMapActions,
  selectors as searchMapSelectors,
} from '@rover/react-lib/src/pages/search/SearchPage/SearchMap.duck';
import { selectors as currentCountryConfigurationSelectors } from '@rover/react-lib/src/redux/ducks/countryConfiguration.duck';
import { selectors as searchSelectors } from '@rover/react-lib/src/redux/ducks/search.duck';
import type { UserInformationAddress } from '@rover/rsdk/src/apiClient/latest/model/userInformationAddress';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';
import settings from '@rover/shared/js/utils/rover-settings';

import SearchMap from './SearchMap';

type Props = {
  onMapMoved: (arg0: MapMetadata) => void;
  onMarkerClick: (index: number) => void;
  onZoomChanged: (arg0: MapMetadata) => void;
  children?: React.ReactNode;
  options?: Record<string, string | boolean>;
  onHomeAddressEdit: (newAddressData: UserInformationAddress) => void;
};

const actions = {
  onMouseOver: searchMapActions.resultMarkerHovered,
  onMouseOut: searchMapActions.resultMarkerHoveredOut,
};

const selector = (state) => ({
  center: searchSelectors.getCenterLatLng(state),
  mapData: searchSelectors.getMapData(state),
  searchResults: searchSelectors.getSearchResults(state),
  bestMatchResults: searchSelectors.getBestMatchSearchResults(state),
  searchInitiatedByMap: searchSelectors.getSearchInitiatedByMap(state),
  mapStyle: currentCountryConfigurationSelectors.getGoogleMapsConfiguration(state),
  hoveringResultIndex: searchMapSelectors.getHoveringResultIndex(state),
  zIndex: searchMapSelectors.getMarkerZIndex(state),
  showRankOnMarker: searchMapSelectors.getShowRankOnMarker(state),
  baseTags: searchMapSelectors.getBaseEventTags(state),
});

const SearchMapContainer = (props: Props): JSX.Element => {
  return (
    <Connect actions={actions} selector={selector}>
      {(connectedProps) => (
        <APIProvider
          apiKey={settings.GOOGLE_MAPS_JAVASCRIPT_KEY}
          version="quarterly"
          libraries={['marker']}
          onError={() => emitAnalyticsEvent(new GeoMapLoadErrorEvent({ error: 'api key error' }))}
        >
          <SearchMap {...connectedProps} {...props} />
        </APIProvider>
      )}
    </Connect>
  );
};

export default SearchMapContainer;
